import { render, staticRenderFns } from "./PatientEducationTool.vue?vue&type=template&id=174ebefc&scoped=true"
import script from "./PatientEducationTool.vue?vue&type=script&lang=js"
export * from "./PatientEducationTool.vue?vue&type=script&lang=js"
import style0 from "./PatientEducationTool.vue?vue&type=style&index=0&id=174ebefc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ebefc",
  null
  
)

export default component.exports